import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RankingTabsRoutingModule } from './ranking-tabs-routing.module';
import { BootstrapRankingTabsComponent } from './bootstrap-ranking-tabs/bootstrap-ranking-tabs.component';
import { CommonPageComponentsModule } from '../common-page-components/common-page-components.module';


@NgModule({
  declarations: [BootstrapRankingTabsComponent],
  imports: [
    CommonModule,
    RankingTabsRoutingModule,
    CommonPageComponentsModule
  ]
})
export class RankingTabsModule { }
